import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Array }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }

  renderChart() {
    if (!this.hasCanvasTarget || !Array.isArray(this.dataValue) || this.dataValue.length === 0) return

    const labels = this.dataValue.map((point) => {
      const date = new Date(point.date)
      return date.toLocaleDateString(undefined, { month: "short", day: "numeric" })
    })

    const datasetFor = (key, label, color) => ({
      label: label,
      data: this.dataValue.map((point) => point[key] ?? null),
      borderColor: color,
      backgroundColor: "transparent",
      borderWidth: 2,
      pointRadius: 0,
      pointHoverRadius: 4,
      tension: 0.2
    })

    this.chart = new Chart(this.canvasTarget.getContext("2d"), {
      type: "line",
      data: {
        labels: labels,
        datasets: [
          datasetFor("gold", "Gold (GLD)", "#b7791f"),
          datasetFor("silver", "Silver (SLV)", "#7c8696"),
          datasetFor("dxy", "Dollar index", "#1f6f8b"),
          datasetFor("yield_10y", "10Y yield", "#3f8f5f")
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index"
        },
        plugins: {
          legend: {
            position: "top",
            align: "end"
          }
        },
        scales: {
          y: {
            ticks: {
              callback: (value) => `${value}`
            }
          }
        }
      }
    })
  }
}
